import React from 'react';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Title from '../../elements/Title';


const useStyles = makeStyles({
  depositContext: {
    flex: 1,
  },
});

export default function DashboardClientsCounter(props) {
  const classes = useStyles();
  return (
    <>
    <React.Fragment>
      <Title>Staff</Title>
      <Typography component="p" variant="h4">
        {props.clients}
      </Typography>
      <Typography color="textSecondary" className={classes.depositContext}>
        last updated {props.lastUpdated}
      </Typography>
      <div>
        <Link color="primary" href="/staff" >
          View Staff
        </Link>
      </div>
    </React.Fragment>
    </>
  );
}